<template>
  <auto-height :margin="margin" class="send-list-container">
    <div class="row h-100">
      <div class="col d-flex flex-column h-100">
        <el-collapse-transition>
          <filter-labels
              v-show="hasLabels"
              :namespace="filterNamespace"
              class="mb-1"
          ></filter-labels>
        </el-collapse-transition>
        <el-collapse-transition>
          <div v-show="isFilterVisible">
            <filters-wrapper
                :namespace="filterNamespace"
            ></filters-wrapper>
          </div>
        </el-collapse-transition>
        <div class="d-flex">
          <input-debounced
              :value="filters.search"
              clearable
              autofocus
              placeholder="Search"
              class="search-bar mb-2"
              @input="updateSearchFilter"
          ></input-debounced>
          <el-popover
              placement="top"
              trigger="hover"
              content="Refresh list"
              :open-delay="500"
          >
            <button slot="reference" class="btn btn-purple align-self-start ml-1" @click="refreshList">
              <i class="fas fa-sync" v-bind:class="{'fa-spin': isListRefreshingActive}"></i>
            </button>
          </el-popover>
          <el-popover
              placement="top"
              trigger="hover"
              content="Toggle filter"
              :open-delay="500"
          >
            <button slot="reference" class="btn btn-purple align-self-start ml-1" @click="filterToggle">
              <i class="fas fa-filter"></i>
            </button>
          </el-popover>
        </div>
        <list
            ref="list"
            :url="url"
            @select="onSelect"
            @quick-message="onSendQuickMessage"
            @email-message="(e) => $emit('email-message', e)"
            @edit="onEdit"
            @delete="onDelete"
            @refresh-start="onListRefreshStarted"
            @refresh-finish="onListRefreshFinished"
            class="list"
        ></list>
      </div>
    </div>
  </auto-height>
</template>

<script>
import List from '../../../components/send-list/list';
import AutoHeight from '../../../components/auto-height';
import {addQueryParams} from "../../../libs/url";
import InputDebounced from '../../../components/input-debounced';
import FiltersWrapper from './filter/filter-wrapper';
import FilterLabels from '../../../components/filter/v2/labels';
import {mapState, mapGetters, mapMutations} from 'vuex';

const filterNamespace = 'sendListFilter';

export default {
  components: {
    List,
    AutoHeight,
    InputDebounced,
    FiltersWrapper,
    FilterLabels,
  },

  props: {
    margin: {
      type: Number,
      default: 0,
    },
    baseUrl: String,
    contactSearchUrl: String,
  },

  data() {
    return {
      current: null,
      isListRefreshingActive: false,
      isFilterVisible: false,
      filterList: {
        search: {
          component: 'TextFilter',
          fields: {
            search: {}
          },
          displayFilter: false,
          clearable: true,
          placeholders: 'Search',
        },
        contact_id: {
          component: 'ContactFilter',
          fields: {
            contact_id: {alias: 'contact'}
          },
          displayFilter: true,
          clearable: true,
          placeholders: 'Contact',
          multiple: false,
          url: this.contactSearchUrl,
          reserveKeyword: false,
        },
      },
    };
  },

  computed: {
    ...mapState(filterNamespace, ['filters']),

    ...mapGetters(filterNamespace, ['hasLabels']),

    /**
     * @return {string}
     */
    filterNamespace() {
      return filterNamespace;
    },

    /**
     * @return {String}
     */
    url() {
      return addQueryParams(this.baseUrl, this.filters);
    },
  },

  methods: {
    ...mapMutations(filterNamespace, {
      updateFilters: 'updateFilters',
      setFilterItems: 'setItems',
    }),

    /**
     * @param {string} value
     */
    updateSearchFilter(value) {
      this.updateFilters({
        name: 'search',
        values: value ? {search: value} : {}
      });
    },

    /**
     * @return {undefined}
     */
    filterToggle() {
      this.isFilterVisible = !this.isFilterVisible;
    },

    /**
     * @param {Object} item
     * @event change
     */
    onSelect(item) {
      this.current = item;
      this.$emit('change', item);
    },

    /**
     * @param {Object} item
     * @event quick-message
     */
    onSendQuickMessage(item) {
      this.$emit('quick-message', item);
    },

    /**
     * @param {Object} item
     * @event edit
     */
    onEdit(item) {
      this.$emit('edit', item);
    },

    /**
     * @param {Object} item
     * @event delete
     */
    onDelete(item) {
      this.$emit('delete', item);
    },

    /**
     * @return {undefined}
     */
    refreshList() {
      this.$refs.list.refresh();
    },

    /**
     * @return {undefined}
     */
    onListRefreshStarted() {
      this.isListRefreshingActive = true;
    },

    /**
     * @return {undefined}
     */
    onListRefreshFinished() {
      this.isListRefreshingActive = false;
    },

    /**
     * @param {Number} id
     */
    removeItemById(id) {
      this.$refs.list.removeItemById(id);
    },
  },

  mounted() {
    this.setFilterItems(this.filterList);
  },
}
</script>
